import { inject, Injectable, computed, signal } from '@angular/core';
import { MetricItemMinimal } from '../api/models';
import { MetricTranslationService } from '../app/services/metric-translation.service';

@Injectable({
  providedIn: 'root',
})
export class MetricCatalogService {
  private readonly metricTranslation = inject(MetricTranslationService);
  private readonly _metrics = signal<MetricItemMinimal[]>([]);

  /** Signal pubblico readonly — lista completa delle metriche. */
  readonly metrics = this._metrics.asReadonly();

  /** True se il catalogo è stato caricato almeno una volta. */
  readonly loaded = computed(() => this._metrics().length > 0);

  /** Popola il catalogo (chiamato al login e come fallback nel config guard). */
  load(list: MetricItemMinimal[]): void {
    this._metrics.set(list);
  }

  getByCode(code: string): MetricItemMinimal | null {
    const metric = this._metrics().find((m) => m.code === code) ?? null;
    if (!metric) return null;
    return { ...metric, label: this.metricTranslation.getLabel(code, metric.label) };
  }

  getUnit(code: string): string | null {
    return this.getByCode(code)?.unit ?? null;
  }

  /** Restituisce la label tradotta basandosi sul code; fallback alla label del BE. */
  getLabel(code: string): string | null {
    const metric = this.getByCode(code);
    if (!metric) return null;
    return this.metricTranslation.getLabel(code, metric.label);
  }

  getId(code: string): string | null {
    return this.getByCode(code)?.id ?? null;
  }

  getNumericId(code: string): number | null {
    return this.getByCode(code)?.numericId ?? null;
  }
}
